// Namibia's cities, towns, villages and main settlements, for "Signed at" on
// the loan agreement: the client picks one; a place not on the list is not
// accepted. Sorted A–Z.
export const NAMIBIAN_TOWNS = [
  'Aranos', 'Ariamsvlei', 'Arandis', 'Aroab', 'Aus',
  'Bagani', 'Berseba', 'Bethanie', 'Bukalo', 'Bunya',
  'Divundu', 'Dordabis', 'Eenhana', 'Eheke', 'Elim', 'Engela', 'Epukiro', 'Epupa', 'Etunda',
  'Gibeon', 'Gobabis', 'Gochas', 'Grootfontein', 'Grünau', 'Gumare',
  'Hardap', 'Helao Nafidi', 'Henties Bay', 'Hoachanas',
  'Kalkfeld', 'Kalkrand', 'Kamanjab', 'Karasburg', 'Karibib', 'Katima Mulilo', 'Katwitwi',
  'Keetmanshoop', 'Khorixas', 'Koës', 'Kongola', 'Kombat', 'Koës',
  'Leonardville', 'Lüderitz',
  'Maltahöhe', 'Mariental', 'Mpungu', 'Mukwe',
  'Nkurenkuru', 'Noordoewer', 'Nyangana',
  'Oranjemund', 'Oshakati', 'Oshikango', 'Oshikuku', 'Okahandja', 'Okahao', 'Okakarara',
  'Okalongo', 'Okombahe', 'Okongo', 'Omaruru', 'Omuthiya', 'Ompundja', 'Ondangwa',
  'Ongenga', 'Ongha', 'Ongwediva', 'Onayena', 'Onesi', 'Oniipa', 'Opuwo', 'Oranjemund',
  'Otavi', 'Otjimbingwe', 'Otjinene', 'Otjiwarongo', 'Outapi', 'Outjo', 'Ovitoto',
  'Rehoboth', 'Rosh Pinah', 'Ruacana', 'Rundu',
  'Schuckmannsburg', 'Seeheim', 'Sesfontein', 'Sesriem', 'Solitaire', 'Stampriet',
  'Swakopmund',
  'Tses', 'Tsandi', 'Tsumeb', 'Tsumkwe',
  'Uis', 'Usakos',
  'Walvis Bay', 'Warmbad', 'Windhoek', 'Witvlei',
].filter((t, i, all) => all.indexOf(t) === i).sort((a, b) => a.localeCompare(b));

const fold = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toLowerCase();

// The town as listed, or null when the text is not one of them (accents and
// case do not matter: "luderitz" is Lüderitz).
export function matchNamibianTown(text) {
  const f = fold(text);
  if (!f) return null;
  return NAMIBIAN_TOWNS.find((t) => fold(t) === f) || null;
}

// Towns that start with, then contain, what was typed (at most `limit`).
export function suggestNamibianTowns(text, limit = 8) {
  const f = fold(text);
  if (!f) return NAMIBIAN_TOWNS.slice(0, limit);
  const starts = NAMIBIAN_TOWNS.filter((t) => fold(t).startsWith(f));
  const contains = NAMIBIAN_TOWNS.filter((t) => !fold(t).startsWith(f) && fold(t).includes(f));
  return [...starts, ...contains].slice(0, limit);
}
